import React, { useEffect } from "react";
import { Camera } from "lucide-react";
import { PassportCard, UploadDocs } from "../../Public/assets"; // Assuming you're using axios for API calls
import { useAuth } from "../../hooks";

function RegisterForm3({ setStateVariable, stateVariable, setImagePreview }) {
  const { errorMessage, handleImageUpload, setErrorMessage } = useAuth();

  useEffect(() => {
    setErrorMessage("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="w-full">
        <div className="flex mb-[5px] justify-between">
          <h1 className="md:w-[80%] text-[26px] font-geomanistMedium text-blackish leading-[34px]">
            Upload the front page of your Passport
          </h1>
          <h2 className=" hidden md:flex w-[20%] text-[16px] text-blueish mt-2  justify-end">
            Step 3/3
          </h2>
        </div>

        <p className="text-[16px] mb-[36px] text-greyish font-geomanistRegular">
          Upload a coloured photo from your gallery
        </p>

        <div className="flex flex-col items-center">
          <div className="flex justify-center mb-[35px]">
            <div className="bg-[#EBEBEB] rounded-full w-[100px] h-[100px] flex items-center justify-center p-[25px]">
              <img src={PassportCard} alt="" />
            </div>
          </div>

          <div className="mb-6 mx-auto">
            <label
              htmlFor="file-upload-gallery"
              className="w-auto md:hidden flex text-white py-[10px] px-4 rounded-md bg-blueish font-geomanistMedium leading-[23px] text-[18px] hover:cursor-pointer"
            >
              <input
                id="file-upload-gallery"
                type="file"
                accept="image/jpeg, image/jpg, image/png"
                className="sr-only"
                onChange={handleImageUpload}
                capture="environment"
              />
              <Camera alt="" className="mr-2" />
              Click Passport (Front)
            </label>

            <h1 className="md:hidden font-geomanistBold text-[16px] flex justify-center my-[30px]">
              OR
            </h1>

            <label
              htmlFor="file-upload"
              className="w-auto flex text-white py-[10px] px-4 rounded-md bg-blueish font-geomanistMedium leading-[23px] text-[18px] hover:cursor-pointer"
            >
              <input
                id="file-upload"
                type="file"
                accept="image/jpeg, image/jpg, image/png"
                className="sr-only"
                onChange={handleImageUpload}
              />
              <img src={UploadDocs} alt="" className="mr-2" />
              Upload Passport (Front)
            </label>
          </div>
          {errorMessage && (
            <div className="text-red-600 text-center mb-4">{errorMessage}</div>
          )}
            <h2 className="text-[14px] mx-[20px] lg:mx-[80px] text-center leading-[20px] text-greyish mt-4">
            <span className="text-red-600">* </span>Upload a coloured image (no black & white)
          </h2>

          <h2 className="text-[14px] mx-[20px] lg:mx-[80px] text-center leading-[20px] text-greyish mt-4">
            <span className="text-red-600">* </span>Accepted Image formats are
            JPEG, JPG And PNG. Maximum allowed image size is 5 MB
          </h2>
        

          <div
            onClick={() => setStateVariable(stateVariable - 1)}
            className="text-blackShade mt-[12px] font-geomanistMedium text-[18px] leading-[24px] underline hover:cursor-pointer"
          >
            Back
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterForm3;
